import { Box, Button, Chip, IconButton, Tooltip, Typography } from '@mui/material'
import { Delete, Edit, Save } from "@mui/icons-material";
import { CustomAutocomplete, CustomCheckbox, CustomDatePicker, CustomDropdown, CustomFileInput, CustomNumberInput, CustomTextarea, CustomTextInput } from 'components/atoms'
import CustomizeChip from 'components/atoms/CustomizeChip'
import CustomTime from 'components/atoms/CustomTime'
import { Add, Eye } from 'iconsax-react'
import React, { useEffect, useRef, useState } from 'react'
import {
    deleteNestedRowByPath,
    generateEmptyRow,
    getValueAtPath,
    getValueByPathArr,
    mergePathWithReference,
    setValueAtPath,
    setValueByFullPath,
    setValueInSimpleObj
} from './utils/utils'
import { cloneDeep } from 'lodash'
import CustomDynamic from './CustomDynamic'
import CustomESign from 'components/atoms/CustomESign';
import { isISODateString } from '../services';
import { getItem } from 'services/utils';
import moment from 'moment';
import { Constants } from 'services/keyConstants';

const NestedRowCell = (props) => {
    const { column, row, mainRowIndex, isAction = false, isFinalAction = false, isMainFinalAction = false, config, path = [], helperFunction, isDisable = false, allColumns, errorRef = false } = props
    const [_, forceRender] = useState({});
    const [esignOpen, setEsignOpen] = useState(false);
    const render = () => forceRender({})
    const storeRef = useRef(null)
    const value = row?.[column?.uniqueName]

    const cellError = getValueByPathArr(errorRef?.current?.staticErrors, path)
    const { error = false, msg: errorMsg = "" } = !!cellError ? cellError : { error: false, msg: '' }

    const {
        renderRows,
        columns,
        rowIndex,
        columnIndex,
        rows,
        multipleESign = false,
        dynamicReadable = false,
        dynamicReadableRef,
        dynamicType = false,
        dynamicTypeRef,
        onSubmit,
        onESign,
        onDelete,
        isViewMode,
        isLock,
        dynamicActions = false,
        dependencyFields = false,
        dynamicOptionsByRows = false,
        dynamicOptionsByCells = false,
        rowByOptions,
        onChangeHandler = false,
        handleDynamicType = false,
        handleSpecificDynamicType = false,
        dynamicViewMode = false,
        trackChanges,
        actions = false,
    } = config
    const {
        handleBtnClick,
        setterHelperByRows = false
    } = helperFunction;

    const passCurrData = {
        path,
        column,
        row,
        columns,
        rows,
        mainRowIndex,
    }

    const isHaveDynamicType = getValueByPathArr(dynamicTypeRef, path) ?? false
    const isDynamicReadable = getValueByPathArr(dynamicReadableRef, path) ?? false
    const isHaveDynamicOptions = getValueAtPath(rowByOptions[mainRowIndex], path.filter(p => typeof p !== "number")) ?? false

    const handleChange = (newValue, changeMethod = null, atFirstTime = false) => {

        if (!!onChangeHandler) {
            const changeHandler = Object.keys(onChangeHandler)
            changeHandler.forEach((ky) => {
                const filterPath = path.filter((p) => (typeof p !== "number")).join(".")
                if (filterPath === ky) {
                    const { before = () => { }, after = () => { } } = onChangeHandler[ky]
                    before(() => {
                        handleUpdateValue(newValue, changeMethod, atFirstTime)
                        after(cloneDeep(passCurrData))
                    }, {
                        newValue: newValue,
                        ...(!!changeMethod && { changeHandler })
                    })
                    return
                }
                handleUpdateValue(newValue, changeMethod, atFirstTime)
            })
            return
        }
        handleUpdateValue(newValue, changeMethod, atFirstTime)
    }

    const handleUpdateValue = (newValue, changeMethod, atFirstTime = false) => {
        row[column?.uniqueName] = newValue
        !atFirstTime && setValueAtPath(trackChanges, path, newValue)

        !atFirstTime && error && setValueAtPath(errorRef.current.staticErrors, path, { error: false, msg: '' })

        const currentPath = path.filter((p => typeof p !== "number")).join(".")

        let renderNeeded = false

        if (!!dynamicType) {
            const dynamicTypeKeys = Object.keys(dynamicType)
            if (dynamicTypeKeys.includes(currentPath)) {
                const { type = "row", handler = () => { } } = dynamicType[currentPath]
                if (type === "row") {
                    const newData = handler(cloneDeep({ ...passCurrData, currentPath })) ?? {}
                    Object.keys(newData).forEach((key) => {
                        const acceptedKey = mergePathWithReference(path, key.split("."))
                        setValueAtPath(dynamicTypeRef, acceptedKey, newData[key])
                    })
                    renderNeeded = true
                }
            }
        }

        if (!!dynamicReadable) {
            const dynamicReadableKeys = Object.keys(dynamicReadable)
            if (dynamicReadableKeys.includes(currentPath)) {
                const { type = "row", handler = () => { } } = dynamicReadable[currentPath]
                if (type === "row") {
                    const newData = handler(cloneDeep({ ...passCurrData, currentPath })) ?? {}
                    Object.keys(newData).forEach((key) => {
                        const acceptedKey = mergePathWithReference(path, key.split("."))
                        setValueAtPath(dynamicReadableRef, acceptedKey, newData[key])
                    })
                    renderNeeded = true
                }
            }
        }

        if (!!dependencyFields) {
            const dependencyFieldsKeys = Object.keys(dependencyFields)
            if (dependencyFieldsKeys.includes(currentPath)) {
                const { type = "row", handler = () => { } } = dependencyFields[currentPath]
                if (type === "row") {
                    const newData = handler(cloneDeep({ ...passCurrData, currentPath })) ?? {}
                    Object.keys(newData).forEach((key) => {
                        const acceptedKey = mergePathWithReference(path, key.split("."))
                        setValueAtPath(rows, acceptedKey, newData[key])
                    })
                    renderNeeded = true
                } else if (type === "table" && !atFirstTime) {
                    setterHelperByRows({ ...passCurrData, currentPath }, dependencyFields[currentPath])
                }
            }
        }

        if (!!dynamicOptionsByCells && !atFirstTime) {
            const dynamicOptionsByCellsKeys = Object.keys(dynamicOptionsByCells)
            if (dynamicOptionsByCellsKeys.includes(currentPath)) {
                const { type = "row", handler = () => { } } = dynamicOptionsByCells[currentPath]
                if (type === "row") {
                    const newData = handler(cloneDeep({ ...passCurrData, currentPath })) ?? {}
                    Object.keys(newData).forEach((key) => {
                        const splitKey = key.split(".")
                        if (["current", "-current"].includes(splitKey?.[0])
                        ) {
                            if (key.split(".")?.[0] === "current") {
                                const orgPath = path.slice(0, -1)
                                orgPath.push(...splitKey.slice(1))
                                if (splitKey.includes("all")) {
                                    setValueByFullPath(rows[mainRowIndex], allColumns, cellByOptions[mainRowIndex], orgPath.slice(1), newData[key], cellByOptions[mainRowIndex])
                                } else {
                                    setValueAtPath(cellByOptions, orgPath, newData[key])
                                }
                            }
                        } else {
                            const acceptedKey = mergePathWithReference(path, key.split("."))
                            setValueAtPath(cellByOptions, acceptedKey, newData[key])
                        }
                    })
                    renderNeeded = true
                }
            }
        }

        if (!!dynamicOptionsByRows) {
            const dynamicOptionsByRowsKeys = Object.keys(dynamicOptionsByRows)
            if (dynamicOptionsByRowsKeys.includes(currentPath)) {
                const { type = "row", handler = () => { } } = dynamicOptionsByRows[currentPath]
                if (type === "row") {
                    const newData = handler(cloneDeep({ ...passCurrData, currentPath })) ?? {}
                    Object.keys(newData).forEach((key) => {
                        setValueInSimpleObj(rowByOptions[mainRowIndex], key.split("."), newData[key])
                    })
                }
                renderNeeded = true
            }
        }

        renderNeeded && renderRows.rows[mainRowIndex]()
        render()
    }

    const commonStyle = {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    };

    useEffect(() => {
        handleChange(value, null, true)
    }, [])

    if (column?.uniqueName === "srNo") {
        const isSaveActive =
            typeof onSubmit?.isActive === "boolean"
                ? onSubmit?.isActive
                : typeof onSubmit?.isActive === "function"
                    ? onSubmit?.isActive(passCurrData)
                    : true;

        const isSaveVisible =
            typeof onSubmit?.isVisible === "boolean"
                ? onSubmit?.isVisible
                : typeof onSubmit?.isVisible === "function"
                    ? onSubmit?.isVisible(passCurrData)
                    : true;

        const isDeleteActive =
            typeof onDelete?.isActive === "boolean"
                ? onDelete?.isActive
                : typeof onDelete?.isActive === "function"
                    ? onDelete?.isActive(passCurrData)
                    : true;

        const isDeleteVisible =
            typeof onDelete?.isVisible === "boolean"
                ? onDelete?.isVisible
                : typeof onDelete?.isVisible === "function"
                    ? onDelete?.isVisible(passCurrData)
                    : true;
        return (
            <Box
                sx={{
                    ...commonStyle,
                    width: "100%",
                    gap: "8px",
                }}
            >
                <Typography>{Number(mainRowIndex) + 1}</Typography>
                {!isViewMode && !isLock && !row?.submitted ? (
                    <>
                        {onDelete !== false && isDeleteVisible ? (
                            <Tooltip title={"Delete row"} arrow>
                                <IconButton
                                    color="error"
                                    // onClick={!!handleDelete ? handleDelete : () => { }}
                                    disabled={rows?.length === 1 || !isDeleteActive}
                                >
                                    <Delete />
                                </IconButton>
                            </Tooltip>
                        ) : null}
                        {onSubmit?.type === "row" && isSaveVisible ? (
                            <Tooltip title={"Submit row"} arrow>
                                <IconButton
                                    color="success"
                                    onClick={() => {
                                        handleBtnClick(
                                            "submit",
                                            row,
                                            rowIndex,
                                            column,
                                            columnIndex,
                                            mainRowIndex
                                        );
                                    }}
                                    disabled={!isSaveActive}
                                >
                                    <Save />
                                </IconButton>
                            </Tooltip>
                        ) : null}
                    </>
                ) : null}
            </Box>

        );
    } else if (isAction) {
        let finalActions = []
        let customStyles = {}
        if (!!isMainFinalAction) {
            if (typeof actions === "function") {
                finalActions = actions(cloneDeep(passCurrData))
            } else {
                const { sx = {}, handler = () => { } } = actions ?? {}
                finalActions = handler(cloneDeep(passCurrData))
                customStyles = sx
            }
        }

        return (
            <Box
                sx={{
                    ...commonStyle,
                    height: '100%',
                    justifyContent: 'space-around',
                    ...customStyles
                }}
            >
                {!isViewMode ? (
                    <>
                        <IconButton
                            color='error'
                            onClick={() => {
                                if (path?.length > 2) {
                                    const updatedRow = deleteNestedRowByPath(rows[mainRowIndex], path.slice(1, -1))
                                    rows[mainRowIndex] = updatedRow
                                    renderRows.rows[mainRowIndex]()
                                } else {
                                    const updateRow = rows.filter((_, ri) => (ri !== mainRowIndex))
                                    rows.length = 0
                                    updateRow.forEach((r, ri) => {
                                        rows.push(r)
                                    })
                                    renderRows.allRows()
                                }
                            }}
                            disabled={getValueByPathArr(rows, path.slice(0, -2))?.length < 2}
                        >
                            <Delete />
                        </IconButton>

                        {
                            isMainFinalAction && (
                                finalActions?.map((actionBtn, actionIdx) => {

                                    const actBtnVisible =
                                        typeof actionBtn?.isVisible === "boolean"
                                            ? actionBtn?.isVisible
                                            : actionBtn.isVisible(cloneDeep(passCurrData), actionBtn)
                                    const actBtnDisable =
                                        typeof actionBtn?.isActive === "boolean"
                                            ? actionBtn?.isActive
                                            : actionBtn.isActive(cloneDeep(passCurrData), actionBtn)

                                    return (
                                        !!actBtnVisible && (<Tooltip key={actionIdx} title={actionBtn?.tooltip || actionBtn?.name} arrow>
                                            <IconButton
                                                color={actionBtn?.color}
                                                onClick={() => {
                                                    actionBtn?.onClick(
                                                        cloneDeep(passCurrData),
                                                        renderRows?.rows[mainRowIndex],
                                                        renderRows?.allRows
                                                    )
                                                }}
                                                disabled={!actBtnDisable}
                                            >
                                                {actionBtn?.icon}
                                            </IconButton>
                                        </Tooltip>)
                                    )
                                })
                            )
                        }

                        {!isFinalAction && (
                            <IconButton
                                color='success'
                                onClick={() => {
                                    const emptyRow = generateEmptyRow(column?.value)
                                    row[column?.uniqueName].push(emptyRow)
                                    renderRows.rows[mainRowIndex]()
                                }}
                            >
                                <Add />
                            </IconButton>)}
                    </>
                ) : (
                    <>
                        <Chip
                            label="Disable"
                            color='error'
                        />
                    </>
                )}

            </Box >
        )

    } else if (
        isViewMode ||
        isLock ||
        (isDisable && value !== "" && value?.length !== 0) ||
        row?.submitted ||
        !!isDynamicReadable ||
        !!column?.isReadOnly
    ) {
        let cellValue = null;
        if (
            Array.isArray(row?.[column?.uniqueName]) &&
            !["dynamic"].includes(column?.type)
        ) {
            cellValue = column?.renderOptionValue
                ? row?.[column?.uniqueName]
                    ?.map((o) => o?.[column?.renderOptionValue])
                    ?.join(", ")
                : row?.[column?.uniqueName]?.length !== 0
                    ? row?.[column?.uniqueName]?.join(", ")
                    : null;
        } else if (column?.type === "esign") {
            const { time = false, userData = {} } = value ?? {}
            const constFormate = getItem(Constants?.DATE_FORMATE);

            cellValue = (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                >

                    <Box
                        sx={{
                            py: '6px',
                            display: 'flex',
                            flexDirection: 'column',
                            // alignItems: 'flex-start'
                            alignItems: 'center'
                        }}
                    >

                        <Typography variant="h6" color="text.primary"  >{userData?.name ?? "N/A"}</Typography>
                        <Typography variant="h6" color="text.primary">{userData?.designation ?? "N/A"}</Typography>
                        <Typography variant="h6" color="text.primary">
                            {
                                isISODateString(time)
                                    ? moment(time).format(!!constFormate ? constFormate : "DD/MM/YYYY hh:mm A")
                                    : time ?? "N/A"
                            }
                        </Typography>
                    </Box >
                </Box>
            )
        } else if (column?.type === "date") {
            const constFormate = getItem(Constants?.DATE_FORMATE);
            cellValue = isISODateString(value)
                ? moment(value).format(!!constFormate ? constFormate : "DD/MM/YYYY")
                : value;
        } else if (column?.type === "dynamicDropdown") {
            cellValue =
                typeof value === "string"
                    ? value
                    : Array.isArray(value)
                        ? value.join(", ")
                        : value?.[column?.renderOptionValue];
        } else if (column?.type === "dropdown") {
            cellValue =
                typeof value === "string"
                    ? value
                    : Array.isArray(value)
                        ? value.join(", ")
                        : value?.[column?.renderOptionValue];
        } else if (column?.type === 'checkbox') {
            return (
                <CustomCheckbox
                    label={column?.name}
                    name={column.uniqueName}
                    checked={!!value}
                    onChange={() => { }}
                    disabled={isViewMode}
                />
            );
        } else if (column?.type === "dynamic") {
            const isActionsVisible = !!dynamicActions?.[column?.uniqueName]
                ? dynamicActions?.[column?.uniqueName]?.isVisible ?? true
                : true;

            const dynamicElements = !!isHaveDynamicType
                ? isHaveDynamicType
                : column?.elements;

            const isHaveMultiple = column?.multipleValues ?? false

            let finalData;

            dynamicViewMode && Object.keys(dynamicViewMode).forEach((key) => {
                if (key === path.filter((k) => typeof k !== "number").join(".")) {
                    const { type = "row", handler = () => { } } = dynamicViewMode[key] ?? {}
                    if (type == "row") {
                        finalData = handler(
                            cloneDeep(passCurrData),
                            cloneDeep({
                                data: row[column?.uniqueName],
                                path,
                                isHaveMultiple,
                                elements: dynamicElements,
                                row: rows[mainRowIndex],
                                currentSubRow: row
                            }))
                    }
                }
            })
            return (finalData);
        } else if (column?.type === "file") {
            return (
                <Box
                    sx={{
                        ...commonStyle,
                    }}
                >
                    <CustomFileInput
                        label={column.name}
                        name={column.uniqueName}
                        value={value}
                        onChange={(e) => {
                            handleChange(e?.target?.value);
                        }}
                        multiple={column?.multiple}
                        error={error}
                        helperText={errorMsg}
                        isLock={isLock}
                        isReadOnly={true}
                    />
                </Box>
            );
        } else {
            const actionsConfig = dynamicActions?.[column?.uniqueName];
            const isActionsVisible =
                typeof actionsConfig?.isVisible === "function"
                    ? actionsConfig.isVisible(row)
                    : actionsConfig?.isVisible ?? true;

            const cellValue = Array.isArray(value) ? value.join(", ") : value;

            return (
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        ...commonStyle,
                    }}
                >
                    <Typography variant="body1" sx={{ flex: 1 }}>
                        {cellValue || "-"}
                    </Typography>

                    {isActionsVisible &&
                        actionsConfig?.actions?.map((action, index) => {
                            const show =
                                typeof action?.isVisible === "function"
                                    ? action.isVisible(row)
                                    : action?.isVisible ?? true;

                            const isActive =
                                typeof action?.isActive === "function"
                                    ? action.isActive(row)
                                    : action?.isActive ?? true;

                            return show ? (
                                <IconButton
                                    key={index}
                                    color={action?.color ?? "default"}
                                    disabled={!isActive}
                                    title={action?.tooltip}
                                    onClick={() =>
                                        action?.handler?.(row, {
                                            value,
                                            index,
                                            action,
                                        })
                                    }
                                >
                                    {action?.icon ?? <Edit />}
                                </IconButton>
                            ) : null;
                        })}
                </Box>
            );
        }

        return <Typography>{cellValue === null ? "N/A" : cellValue}</Typography>;
    } else if (column?.type === "dynamic") {
        // const isActionsVisible = !!dynamicActions?.[column?.uniqueName]
        //     ? dynamicActions?.[column?.uniqueName]?.isVisible ?? true
        //     : true;

        const isHaveMultiple = column?.multipleValues ?? false

        const dynamicElement = !!isHaveDynamicType
            ? isHaveDynamicType
            : column?.elements;

        if (isHaveMultiple) {
            if (!row[column.uniqueName] || (row[column.uniqueName] === "")) {
                row[column.uniqueName] = [];
            }
            if (Array.isArray(row[column.uniqueName]) && row[column.uniqueName].length === 0) {
                row[column.uniqueName].push({});
            }
        } else {
            if (row[column.uniqueName] && typeof row[column.uniqueName] === 'object') {
                const hasKeys = Object.keys(row[column.uniqueName]).length > 0;
                if (!hasKeys) {
                    row[column.uniqueName] = {};
                }
            } else if (!row[column.uniqueName]) {
                row[column.uniqueName] = {};
            }
        }

        return (
            <Box>
                {isHaveMultiple ? (
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '15px',
                            // border : '1px solid red'
                        }}
                    >
                        <Box>
                            {
                                Array.isArray(row[column.uniqueName]) && row[column.uniqueName]?.map((v, vi) => {

                                    let finalDynamicType = dynamicElement

                                    if (!!handleDynamicType) {
                                        Object.keys(handleDynamicType).forEach((key) => {
                                            if (key === path.filter(p => typeof p !== "number").join(".")) {
                                                const { type = "row", handler = () => { } } = handleDynamicType[key];
                                                if (type === "row") {
                                                    const { currentDynamicType = {}, ...rest } = storeRef.current?.dynamicTypedata ?? {}
                                                    const newData =
                                                        handler(
                                                            cloneDeep(passCurrData),
                                                            cloneDeep({
                                                                dataIndex: vi,
                                                                curentDynamicType: currentDynamicType,
                                                                oldValue: {
                                                                    ...(rest ? rest : {})
                                                                },
                                                                updatedData: {
                                                                    allData: row?.[column?.uniqueName],
                                                                    specificData: row?.[column?.uniqueName][vi],
                                                                    dynamicType: dynamicElement,
                                                                    value: row?.[column?.uniqueName]?.[vi]?.[currentDynamicType?.uniqueName],
                                                                },
                                                            }))
                                                    if (Array.isArray(newData) && (newData.length > 0)) {
                                                        finalDynamicType = newData
                                                    }
                                                }

                                            }
                                        })
                                    }

                                    return (
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                gap: '15px',
                                                alignItems: 'center',
                                                justifyContent: 'space-around'
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    alignItems: 'center',
                                                    justifyContent: 'space-between',
                                                    overflowX: "auto",
                                                    gap: '10px',
                                                    paddingY: "10px",
                                                    scrollbarWidth: "thin",
                                                    scrollbarColor: "#0000FF #00000000",
                                                }}
                                            >

                                                {true
                                                    ? dynamicActions?.[column?.uniqueName]?.actions?.map((action) =>
                                                        !!action?.isVisible ? (
                                                            <IconButton
                                                                color={action?.color ?? "default"}
                                                                disabled={!action?.isActive ?? false}
                                                                onClick={() => {
                                                                    action?.handler(passCurrentData, {
                                                                        value: element,
                                                                        index: elementIndex,
                                                                        action,
                                                                    });
                                                                }}
                                                            >
                                                                {action?.icon ?? <Edit />}
                                                            </IconButton>
                                                        ) : null
                                                    )
                                                    : null
                                                }

                                                {
                                                    finalDynamicType?.map((element, elementIndex) => {
                                                        return (
                                                            <CustomDynamic
                                                                element={element}
                                                                elementIndex={elementIndex}
                                                                elements={finalDynamicType}
                                                                data={row[column?.uniqueName]}
                                                                currentData={row[column?.uniqueName][vi]}
                                                                cellRef={v}
                                                                path={path}
                                                                parantRender={() => {
                                                                    handleChange(row?.[column?.uniqueName])
                                                                }}
                                                                specificRender={(oldValue) => {
                                                                    storeRef.current = {
                                                                        ...storeRef.current,
                                                                        dynamicTypedata: oldValue
                                                                    }
                                                                    render()
                                                                }}
                                                                handleSpecificDynamicType={handleSpecificDynamicType}
                                                                errorRef={errorRef?.current?.dynamicError ?? false}
                                                                metadata={{
                                                                    mainRowIndex,
                                                                    isHaveMultiple,
                                                                    currentMultipleStageIndex: vi,
                                                                    trackChanges,
                                                                }}
                                                            />
                                                        )

                                                    })
                                                }
                                            </Box>
                                            {
                                                !!column?.tag && (
                                                    <Typography variant='body1'>{column?.tag}</Typography>
                                                )
                                            }
                                            {
                                                true && (
                                                    <Box>
                                                        <IconButton
                                                            color='error'
                                                            onClick={() => {
                                                                const updateValue = row?.[column?.uniqueName]?.filter((_, valIndex) => (valIndex !== vi))
                                                                row[column?.uniqueName].length = 0
                                                                updateValue?.forEach((val => {
                                                                    row?.[column?.uniqueName]?.push(val)
                                                                }))
                                                                const currentPath = cloneDeep(path)
                                                                const multiElements = getValueAtPath(trackChanges, currentPath)
                                                                const newMultiElements = []
                                                                multiElements?.forEach((e, ei) => {
                                                                    ei !== vi ? newMultiElements?.push(e) : null
                                                                })
                                                                setValueAtPath(trackChanges, currentPath, newMultiElements)
                                                                render()
                                                            }}
                                                            disabled={row?.[column?.uniqueName]?.length < 2}
                                                        >
                                                            <Delete />
                                                        </IconButton>
                                                    </Box>
                                                )
                                            }
                                        </Box>
                                    )
                                })
                            }

                        </Box>

                        {
                            true && (
                                <Box>
                                    <Button
                                        variant='outlined'
                                        sx={{
                                            width: '100%'
                                        }}
                                        onClick={() => {
                                            row[column?.uniqueName].push({})
                                            render()
                                        }}
                                    >
                                        {<Add />} Add {column?.name}
                                    </Button>
                                </Box>
                            )
                        }

                    </Box>


                ) : (
                    <Box
                        sx={{
                            display: 'flex',
                        }}
                    >
                        {/* {isActionsVisible
                            ? dynamicActions?.[column?.uniqueName]?.actions?.map((action) =>
                                !!action?.isVisible ? (
                                    <IconButton
                                        color={action?.color ?? "default"}
                                        disabled={!action?.isActive ?? false}
                                        onClick={() => {
                                            action?.handler(passCurrentData, {
                                                value: element,
                                                index: elementIndex,
                                                action,
                                            });
                                        }}
                                    >
                                        {action?.icon ?? <Edit />}
                                    </IconButton>
                                ) : null
                            )
                            : null} */}

                        {
                            [1].map(() => {

                                let finalDynamicType = dynamicElement

                                if (!!handleDynamicType && storeRef.current?.dynamicTypedata) {
                                    Object.keys(handleDynamicType).forEach((key) => {
                                        if (key === path.filter(p => typeof p !== "number").join(".")) {
                                            const { type = "row", handler = () => { } } = handleDynamicType[key];
                                            if (type === "row") {
                                                const { currentDynamicType = {}, currentIndex: actionIndex, ...rest } = storeRef.current?.dynamicTypedata ?? {}
                                                const newData =
                                                    handler(
                                                        cloneDeep(passCurrData),
                                                        cloneDeep({
                                                            actionIndex,
                                                            curentDynamicType: currentDynamicType,
                                                            oldValue: {
                                                                ...(rest ? rest : {})
                                                            },
                                                            updatedData: {
                                                                allData: row?.[column?.uniqueName],
                                                                specificData: row?.[column?.uniqueName][[currentDynamicType?.uniqueName]],
                                                                dynamicType: dynamicElement,
                                                                value: row?.[column?.uniqueName]?.[currentDynamicType?.uniqueName],
                                                            },
                                                        })
                                                    )

                                                if (Array.isArray(newData) && (newData.length > 0)) {
                                                    finalDynamicType = newData
                                                }
                                            }
                                        }
                                    })
                                }

                                return (
                                    <>
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                overflowX: 'auto',
                                                padding: '10px',
                                                scrollbarWidth: 'thin',
                                                scrollbarColor: '#0000FF #00000000',
                                                gap: '20px'
                                            }}
                                        >
                                            {finalDynamicType?.map((element, elementIndex) => {
                                                return (
                                                    <CustomDynamic
                                                        element={element}
                                                        elementIndex={elementIndex}
                                                        elements={dynamicElement}
                                                        cellRef={row?.[column?.uniqueName]}
                                                        path={path}
                                                        data={row[column?.uniqueName]}
                                                        currentData={row[column?.uniqueName][element?.uniqueName]}
                                                        parantRender={() => {
                                                            handleChange(row?.[column?.uniqueName]);
                                                        }}
                                                        specificRender={(oldValue) => {
                                                            storeRef.current = {
                                                                ...storeRef.current,
                                                                dynamicTypedata: oldValue,
                                                            };
                                                            render();
                                                        }}
                                                        handleSpecificDynamicType={handleSpecificDynamicType}
                                                        errorRef={errorRef?.current?.dynamicError ?? false}
                                                        metadata={{
                                                            mainRowIndex,
                                                            trackChanges,
                                                        }}
                                                    />
                                                );
                                            })}
                                        </Box>
                                    </>
                                );
                            })
                        }

                        {/* {
                            dynamicElement?.map((element, elementIndex) => {

                                return (
                                    <CustomDynamic
                                        element={finalElement}
                                        elementIndex={elementIndex}
                                        elements={dynamicElement}
                                        cellRef={row?.[column?.uniqueName]}
                                        sx={{
                                            // maxWidth: "200px",
                                        }}
                                        parantRender={() => {
                                            handleChange(row?.[column?.uniqueName])
                                        }}
                                        specificRender={(oldValue) => {
                                            storeRef.current = {
                                                ...storeRef.current,
                                                dynamicTypedata: oldValue
                                            }
                                            render()
                                        }}
                                    />
                                );
                            })
                        } */}

                    </Box>
                )}
                {!!column?.addNew ? (
                    <Button variant="outlined"> Add New </Button>
                ) : null}
            </Box>
        );
    } else if (column?.type === "text") {
        return (
            <Box
                sx={{
                    ...commonStyle,
                }}
            >
                <CustomTextInput
                    label={`Enter ${column?.name}`}
                    name={column.uniqueName}
                    value={value}
                    onChange={(e) => {
                        handleChange(e?.target?.value);
                    }}
                    error={error}
                    helperText={errorMsg}
                // isLock={isLock || isDisable}
                // isReadOnly={!!column?.isReadOnly}
                />
            </Box>
        )
    } else if (column?.type === "number") {
        return (
            <Box
                sx={{
                    ...commonStyle,
                }}
            >
                <CustomNumberInput
                    label={`Enter ${column?.name}`}
                    name={column.uniqueName}
                    value={value}
                    onChange={(e) => {
                        handleChange(e?.target?.value);
                    }}
                // error={error}
                // helperText={errorMsg}
                // isLock={isLock || isDisable}
                // isReadOnly={!!column?.isReadOnly}
                />
            </Box>
        );
    }
    else if (column?.type === "dropdown") {
        return (
            <Box
                sx={{
                    ...commonStyle,
                }}
            >
                <CustomDropdown
                    label={column.name}
                    name={column.uniqueName}
                    value={value}
                    onChange={(value) => {
                        handleChange(value);
                    }}
                    options={
                        // myRowByOptions.length > 0 ? myRowByOptions : column?.options ?? []
                        isHaveDynamicOptions ? isHaveDynamicOptions : column?.options ?? []
                    }
                    multiple={column?.multiple}
                    renderOptionKey={
                        column?.renderOptionValue ? column?.renderOptionValue : false
                    }
                    error={error}
                    helperText={errorMsg}
                // isLock={isLock || isDisable}
                // isReadOnly={!!column?.isReadOnly}
                />
            </Box>
        );
    } else if (column?.type === "dynamicDropdown") {
        return (
            <Box
                sx={{
                    ...commonStyle,
                }}
            >
                <CustomAutocomplete
                    label={column.name}
                    name={column.uniqueName}
                    value={value}
                    onChange={(value, changeMethod) => {
                        handleChange(value, changeMethod);
                    }}
                    options={
                        // myRowByOptions.length > 0 ? myRowByOptions : column?.options ?? []
                        // column?.options ?? []
                        isHaveDynamicOptions ? isHaveDynamicOptions : column?.options ?? []
                    }
                    multiple={column?.multiple}
                    freeSolo={column?.freeSolo ?? true}
                    renderOptionKey={
                        column?.renderOptionValue ? column?.renderOptionValue : false
                    }
                    selectOne={column?.selectOne ?? false}
                    isReadOnly={!!column?.isReadOnly}
                    error={error}
                    helperText={errorMsg}
                // isLock={isLock || isDisable}
                />
            </Box>
        );
    } else if (column?.type === "textarea") {
        return (
            <Box
                sx={{
                    ...commonStyle,
                }}
            >
                <CustomTextarea
                    label={`Enter ${column?.name}`}
                    name={column.uniqueName}
                    value={value}
                    onChange={(e) => {
                        handleChange(e?.target?.value);
                    }}
                    isReadOnly={!!column?.isReadOnly}
                    error={error}
                    helperText={errorMsg}
                // isLock={isLock}
                />
            </Box>
        );
    } else if (["date", "datetime"]?.includes(column?.type)) {

        if (!value && !moment(value).isValid()) {
          row[column?.uniqueName] = moment().toISOString();
          render();
        }

        return (
            <Box
                sx={{
                    ...commonStyle,
                }}
            >
                <CustomDatePicker
                    label={column.name}
                    name={column.uniqueName}
                    value={value}
                    onChange={(e) => {
                        handleChange(e);
                    }}
                    disablePast={column?.disablePast}
                    isReadOnly={!!column?.isReadOnly}
                    dateTime={column?.type === "datetime"}
                    error={error}
                    helperText={errorMsg}
                    minValue={column?.minValue}
                    maxValue={column?.maxValue}
                // isLock={isLock || isDisable}
                />
            </Box>
        );
    } else if (column?.type === "esign") {
        const beforeOpen = (state) => {
            const before = onESign?.before || {};
            const checkValidation = before?.checkValidation ?? true;
            const handler = before?.handler ?? false;
            if (onESign !== false) {
                // if (checkValidation && !helperUtils("checkValidation", row, rowIndex)) {
                //     return;
                // } 
                if (handler) {
                    handler(state, passCurrData);
                } else {
                    state();
                }
            } else {
                state();
            }
        };
        const handleSubmit = (submitStatus) => {
            if (!!submitStatus) {
                if (multipleESign !== false) {
                    const { format, start } = multipleESign;
                    const isLastStep =
                        row?.currentESignStep === format?.[format.length - 1];
                    if (isLastStep) {
                        delete row?.currentESignStep;
                        row.submitted = true;
                        row.isLock = true;
                    } else {
                        const nextIndex = format?.indexOf(row?.currentESignStep) + 1;
                        row.currentESignStep = format[nextIndex];
                    }
                }
                handleChange(submitStatus);
                onESign?.after?.(true, submitStatus, passCurrData);
                renderRows.rows[mainRowIndex]()
            } else {
                onESign?.after?.(false, null, passCurrData);
                showToast("Submit failed", false);
            }
        };

        return (
            <CustomESign
                open={esignOpen}
                setOpen={setEsignOpen}
                handleSubmit={handleSubmit}
                beforeOpen={beforeOpen}
                disabled={isLock || isDisable}
            />
        );
    } else if (column?.type === "time") {
        return (
            <>
                <CustomTime
                    onChange={(e) => {
                        handleChange(e?.target?.value);
                    }}
                    label={`Enter ${column?.name}`}
                    name={column?.name}
                    value={value}
                    isReadOnly={!!column?.isReadOnly}
                    error={error}
                    helperText={errorMsg}
                // isLock={isLock || isDisable}
                />
            </>
        );
    } else if (column?.type === "file") {
        return (
            <Box
                sx={{
                    ...commonStyle,
                }}
            >
                <CustomFileInput
                    label={column.name}
                    name={column.uniqueName}
                    value={value}
                    onChange={(e) => {
                        handleChange(e?.target?.value);
                    }}
                    multiple={column?.multiple}
                    error={error}
                    helperText={errorMsg}
                // isLock={isLock}
                />
            </Box>
        );
    } else if (column?.type === "checkbox") {
        return (
            <CustomCheckbox
                label={`Enter ${column?.name}`}
                name={column.uniqueName}
                checked={value}
                onChange={(newValue) => {
                    handleChange(newValue);
                }}
                isReadOnly={!!column?.isReadOnly}
                error={error}
                helperText={errorMsg}
                disabled={isViewMode}
            isLock={isLock || isDisable}
            />
        );
    } else {
        return (
            <Box
                sx={{
                    ...commonStyle,
                }}
            >
                <CustomTextInput
                    label={`Enter ${column?.name}`}
                    name={column.uniqueName}
                    value={value}
                    onChange={(e) => {
                        handleChange(e?.target?.value);
                    }}
                    error={error}
                    helperText={errorMsg}
                // isLock={isLock || isDisable}
                />
            </Box>
        );
    }
}

export default NestedRowCell
